import { BlockReason } from '@/services/dtos/accessRequest.dto';

export const ACCESS_SECTION_MESSAGES = {
    REUSED: {
        TITLE: 'Acessos Reaproveitados',
        EMPTY: 'Nenhum reaproveitamento neste fluxo.',
        USERS_LABEL: 'Usuários: ',
        OPERATORS_LABEL: 'Operadores: ',
    },
    BLOCKED: {
        TITLE: 'Acessos Bloqueados',
        USERS_LABEL: 'Usuários: ',
        OPERATORS_LABEL: 'Operadores: ',
    },
    SNAPSHOT: {
        TITLE: 'Snapshot do momento da criação',
        USERS_FOUND_LABEL: 'Usuários ativos no momento: ',
        OPERATORS_FOUND_LABEL: 'Operadores ativos no momento: ',
        PLAN_SOURCE_LABEL: 'Origem do plano: ',
    },
    PLAN_ERROR: 'Detalhes do plano indisponíveis.',
} as const;

export const BLOCK_REASON_LABEL: Record<BlockReason, string> = {
    incompatible_with_role: 'incompatível com o cargo',
    extra_for_role: 'excedente para o cargo',
    legacy_block_all_active: 'bloqueio sistêmico (rotina padrão)',
};

export const PLAN_SOURCE_LABEL: Record<
    'term_flow' | 'retaguarda_legacy',
    string
> = {
    term_flow: 'Termo (criação automática)',
    retaguarda_legacy: 'Retaguarda de Loja (manual)',
};
